import { render } from "./Elements.vue?vue&type=template&id=b22fe38c"
import script from "./Elements.vue?vue&type=script&lang=js"
export * from "./Elements.vue?vue&type=script&lang=js"

import "./Elements.vue?vue&type=style&index=0&id=b22fe38c&lang=css"

import exportComponent from "/var/www/html/projects/rde/resources/vueapps/quotation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__